/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteExternalTransactionReversalRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {CompleteExternalTransactionReversalResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const completeExternalTransactionReversal = (request: CompleteExternalTransactionReversalRequest, options?: CashRequestOptions) => post<CompleteExternalTransactionReversalRequest, CompleteExternalTransactionReversalResponse>("/2.0/cash/complete-external-transaction-reversal", request, {...options, rejectOnError: true })